import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const WifiSurchargeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "WifiSurchargeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.4251 13.3815C10.8633 13.3815 9.40584 14.0804 8.42638 15.2992C8.31471 15.4382 8.26396 15.6123 8.28334 15.7895C8.30241 15.9667 8.38978 16.1254 8.52882 16.2374C8.81429 16.4669 9.23572 16.422 9.46674 16.1353C10.1915 15.2333 11.27 14.7159 12.4251 14.7159C13.5805 14.7159 14.659 15.2333 15.3837 16.1353C15.5108 16.2934 15.7006 16.3844 15.9039 16.3844C16.0553 16.3844 16.2039 16.3321 16.3217 16.2374C16.4607 16.1254 16.5478 15.9667 16.5671 15.7895C16.5862 15.6123 16.5355 15.4382 16.4238 15.2992C15.4446 14.0804 13.9872 13.3815 12.4251 13.3815Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.425 17.1559C11.6787 17.1559 11.0718 17.7631 11.0718 18.5094C11.0718 19.2557 11.6787 19.8629 12.425 19.8629C13.1713 19.8629 13.7785 19.2557 13.7785 18.5094C13.7785 17.7631 13.1713 17.1559 12.425 17.1559ZM12.4437 18.5094C12.4437 18.5279 12.4062 18.5279 12.4062 18.5094C12.4062 18.5002 12.4158 18.4903 12.425 18.4903C12.4342 18.4903 12.4437 18.5002 12.4437 18.5094Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.1437 4.85706C17.1566 4.85706 16.2251 5.17821 15.4502 5.78668C15.2724 5.92634 15.1048 6.08015 14.9525 6.2438C14.7224 6.49051 14.5212 6.76244 14.3548 7.05222C13.9777 7.70991 13.7783 8.46049 13.7783 9.22215C13.7783 11.6296 15.7366 13.5878 18.1437 13.5878C20.5511 13.5878 22.5094 11.6296 22.5094 9.22215C22.5094 6.81535 20.5511 4.85706 18.1437 4.85706ZM21.4887 9.22215C21.4887 11.0666 19.9882 12.5678 18.1437 12.5678C16.2995 12.5678 14.799 11.0666 14.799 9.22215C14.799 8.63952 14.9516 8.06489 15.2401 7.56102C15.3681 7.33831 15.5225 7.12913 15.6988 6.94025C15.8154 6.81474 15.9436 6.69662 16.0805 6.58957C16.6739 6.12384 17.3873 5.87774 18.1437 5.87774C19.9882 5.87774 21.4887 7.3783 21.4887 9.22215Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.1582 8.62496C18.1532 8.62434 17.6629 8.57759 17.6629 8.30258C17.6629 7.843 18.1025 7.81654 18.1517 7.8147C18.2348 7.8147 18.3443 7.87069 18.4304 7.95682C18.4472 7.97363 18.4556 8.03946 18.4556 8.15431C18.4556 8.43547 18.6845 8.66372 18.966 8.66372C19.2474 8.66372 19.4763 8.43424 19.4763 8.15246C19.4763 7.88791 19.4763 7.55937 19.1521 7.23392C18.9817 7.06473 18.7799 6.93738 18.5673 6.86478C18.5175 6.62915 18.3107 6.46057 18.0683 6.46057C17.8041 6.46057 17.5845 6.66237 17.5602 6.92323C17.2698 7.04628 16.6425 7.41603 16.6425 8.30259C16.6425 9.30481 17.6727 9.64442 18.1406 9.64565C18.2249 9.6518 18.6399 9.83391 18.6399 10.1335C18.6399 10.3169 18.5836 10.4245 18.4458 10.5064C18.3018 10.5913 18.1133 10.622 17.985 10.622C17.7752 10.622 17.5838 10.3476 17.5838 10.0462C17.5838 9.765 17.355 9.53613 17.0738 9.53613C16.7923 9.53613 16.5635 9.765 16.5635 10.0462C16.5635 10.7451 16.9763 11.3701 17.5697 11.5732C17.6201 11.8082 17.8269 11.9762 18.0683 11.9762C18.3135 11.9762 18.5258 11.7977 18.5701 11.5578C19.2533 11.3529 19.6606 10.822 19.6606 10.1335C19.6606 9.15714 18.667 8.62496 18.1582 8.62496Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.1484 6.52218C13.1484 6.17274 12.8806 5.87308 12.5318 5.85295C12.2874 5.83885 12.6717 5.83167 12.4249 5.83167C10.625 5.83167 8.88454 6.20203 7.25171 6.93231C5.67671 7.63737 4.28167 8.64082 3.10626 9.91497C2.85678 10.1851 2.8737 10.6083 3.1441 10.8581C3.26838 10.9726 3.42803 11.0347 3.59599 11.0347H3.62368C3.80179 11.0273 3.96637 10.951 4.08695 10.82C6.2292 8.49809 9.26845 7.16672 12.4249 7.16672C12.6383 7.16672 12.2209 7.1745 12.4326 7.18837C12.82 7.21376 13.1484 6.91035 13.1484 6.52218Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.4063 10.3059C12.4063 9.9091 12.0621 9.60604 11.6668 9.63992C9.40768 9.83352 7.291 10.8863 5.77037 12.5959C5.52581 12.8709 5.55073 13.2936 5.82574 13.5385C5.94786 13.6474 6.10536 13.707 6.26871 13.707C6.45913 13.707 6.64093 13.6252 6.76767 13.4831C8.06746 12.0214 9.87936 11.1244 11.8116 10.9669C12.1507 10.9392 12.4063 10.6461 12.4063 10.3059Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default WifiSurchargeIcon;
